var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("el-cascader", {
    ref: "elCascader",
    staticStyle: { width: "100%" },
    attrs: {
      options: _vm.options,
      "show-all-levels": false,
      props: _vm.defaultProps,
      disabled: _vm.disabled,
      "change-on-select": "",
    },
    on: { change: _vm.valueChange },
    model: {
      value: _vm.dataValue,
      callback: function ($$v) {
        _vm.dataValue = $$v
      },
      expression: "dataValue",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }